import {useState,useEffect} from 'react';
import Hero from '../components/Hero';
import { useLanguage } from '../i18n/LanguageContext';
import UnderConstruction from '../components/UnderConstruction';
import { useGenericEffect } from '../components/UseGenericEffect';
import WhyMe from '../content/why_me';
import Services from '../content/services';
// import ForMen from '../content/for_men'; 

export default function HowICanHelp() {
  const { strings } = useLanguage();

  const map = {
    'why_me': <WhyMe lang={strings.lang_code}/>,
    'services': <Services lang={strings.lang_code}/>,
    // 'formen': <ForMen lang={strings.lang_code}/>
  };

  function get(){
    setContent(map[document.getElementById('loadstate').textContent]);
  }
  useGenericEffect(() => {
    get();
  }, [strings.lang_code]);

  const [content, setContent] = useState(map['why_me']);

  return (
    <>
      <Hero title={strings.pages.howICanHelp.title} eyebrow={strings.pages.howICanHelp.eyebrow} />
      <main className="page-content">
          <div className="content-container-menu" id="content-container-menu">     
              <div className="menu-item" onClick={() => get()} id="why_me">{strings.pages.howICanHelp.whyme}</div>     
              {/* <div className="menu-item" onClick={() => get()} id="services">{strings.pages.howICanHelp.services}</div> */}  
              {/* <div className="menu-item" onClick={() => get()} id="formen">{strings.pages.howICanHelp.formen}</div> */}       
          </div> 
          <div className="content-table max-centered">
              <div className="content-container">    
                  <div className="content-container-main show" id="content-container-main">{content}</div>       
              </div>
              <div class="hidden" id="loadstate">why_me</div>
       </div>
      </main>
    </>
  );
}